"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155PresetMinterPauserFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var Erc1155PresetMinterPauserFactory = /** @class */ (function (_super) {
    __extends(Erc1155PresetMinterPauserFactory, _super);
    function Erc1155PresetMinterPauserFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Erc1155PresetMinterPauserFactory.prototype.deploy = function (uri, overrides) {
        return _super.prototype.deploy.call(this, uri, overrides || {});
    };
    Erc1155PresetMinterPauserFactory.prototype.getDeployTransaction = function (uri, overrides) {
        return _super.prototype.getDeployTransaction.call(this, uri, overrides || {});
    };
    Erc1155PresetMinterPauserFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Erc1155PresetMinterPauserFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Erc1155PresetMinterPauserFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return Erc1155PresetMinterPauserFactory;
}(contracts_1.ContractFactory));
exports.Erc1155PresetMinterPauserFactory = Erc1155PresetMinterPauserFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'uri',
                type: 'string',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'previousAdminRole',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'newAdminRole',
                type: 'bytes32',
            },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'values',
                type: 'uint256[]',
            },
        ],
        name: 'TransferBatch',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'TransferSingle',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'value',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
        ],
        name: 'URI',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'PAUSER_ROLE',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
        ],
        name: 'balanceOfBatch',
        outputs: [
            {
                internalType: 'uint256[]',
                name: '',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                internalType: 'uint256[]',
                name: 'values',
                type: 'uint256[]',
            },
        ],
        name: 'burnBatch',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleAdmin',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'getRoleMember',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
        ],
        name: 'getRoleMemberCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'hasRole',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'mint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts',
                type: 'uint256[]',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'mintBatch',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'paused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'role',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts',
                type: 'uint256[]',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeBatchTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'unpause',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'uri',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=Erc1155PresetMinterPauserFactory.js.map